/* Wishlist store. localStorage-backed set of product handles.
   Exposed as window.TPHWishlist. Publishes a "wishlist:change" event
   so cards and the header icon can re-render instantly. */
(() => {
  const KEY = 'tph:wishlist:v1';
  const subs = new Set();

  function load() {
    try {
      const raw = localStorage.getItem(KEY);
      const arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch { return []; }
  }
  function save(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch {}
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: list }));
    subs.forEach((fn) => { try { fn(list); } catch (e) { console.error(e); } });
  }

  window.addEventListener('storage', (e) => {
    if (e.key === KEY) save(load());
  });

  window.TPHWishlist = {
    list: () => load(),
    count: () => load().length,
    has: (h) => load().includes(h),
    toggle(h) {
      const list = load();
      const idx = list.indexOf(h);
      if (idx >= 0) list.splice(idx, 1); else list.push(h);
      save(list);
      return idx < 0;  // true if just added
    },
    add(h)    { const list = load(); if (!list.includes(h)) { list.push(h); save(list); } },
    remove(h) { save(load().filter((x) => x !== h)); },
    clear()   { save([]); },
    subscribe(fn) { subs.add(fn); fn(load()); return () => subs.delete(fn); },
  };

  // Delegated click on any .js-wishlist-toggle — extracts handle from the
  // enclosing .product-card.
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.js-wishlist-toggle');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    const card = btn.closest('.product-card');
    const link = card?.querySelector('.product-card__link');
    const href = link?.getAttribute('href') || '';
    const handle = new URLSearchParams(href.split('?')[1] || '').get('handle');
    if (!handle) return;
    const added = window.TPHWishlist.toggle(handle);
    btn.setAttribute('aria-pressed', added ? 'true' : 'false');
  });

  const HEART_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 1 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78z"/></svg>';

  // Auto-inject a wishlist heart into every .product-card__media that
  // doesn't already have one.
  function injectHearts() {
    document.querySelectorAll('.product-card__media').forEach((media) => {
      if (media.querySelector('.js-wishlist-toggle')) return;
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'product-card__wishlist js-wishlist-toggle';
      btn.setAttribute('aria-label', 'Add to wishlist');
      btn.setAttribute('aria-pressed', 'false');
      btn.innerHTML = HEART_SVG;
      media.appendChild(btn);
    });
    syncButtons(window.TPHWishlist.list());
  }

  document.addEventListener('DOMContentLoaded', injectHearts);
  // MutationObserver handles dynamically rendered cards too (collections,
  // related, recently viewed, search).
  const heartObserver = new MutationObserver((records) => {
    for (const rec of records) {
      for (const node of rec.addedNodes) {
        if (node.nodeType === 1 && (node.matches?.('.product-card') || node.querySelector?.('.product-card'))) {
          injectHearts();
          return;
        }
      }
    }
  });
  heartObserver.observe(document.body, { childList: true, subtree: true });
  // run once in case DOMContentLoaded already fired
  if (document.readyState !== 'loading') injectHearts();

  // Walk every wishlist button on page load and on wishlist changes.
  function syncButtons(list) {
    const set = new Set(list);
    document.querySelectorAll('.js-wishlist-toggle').forEach((btn) => {
      const card = btn.closest('.product-card');
      const link = card?.querySelector('.product-card__link');
      const href = link?.getAttribute('href') || '';
      const handle = new URLSearchParams(href.split('?')[1] || '').get('handle');
      if (!handle) return;
      btn.setAttribute('aria-pressed', set.has(handle) ? 'true' : 'false');
    });
  }
  document.addEventListener('wishlist:change', (e) => syncButtons(e.detail));
  // Also sync when any section re-renders. MutationObserver handles dynamic grids.
  const mo = new MutationObserver(() => syncButtons(window.TPHWishlist.list()));
  mo.observe(document.body, { childList: true, subtree: true });
})();
